import { Controller } from "@hotwired/stimulus"

// Alterna uma classe CSS (padrão `is-hidden`) no(s) alvo(s) `content` ao
// acionar `toggle`. Use class-value para alternar outra classe.
export default class extends Controller {
  static targets = ["content"]
  static values = { class: { type: String, default: "is-hidden" } }

  toggle(event) {
    if (event) event.preventDefault()
    this.contentTargets.forEach((el) => el.classList.toggle(this.classValue))
  }
}
